<template>
  <div class="order-flow-page">
    <div class="flow-content">
      <div class="flow-section">
        <div class="flow-section-title">
          <van-icon name="user-o" />
          <span>买家流程</span>
        </div>
        <div class="flow-steps-buyer">
          <div v-for="(step, index) in buyerSteps" :key="index" class="flow-step-item">
            <div class="step-icon">{{ step.icon }}</div>
            <div class="step-info">
              <div class="step-title">{{ step.title }}</div>
              <div class="step-desc">{{ step.desc }}</div>
            </div>
            <van-icon v-if="index < buyerSteps.length - 1" name="arrow" class="step-arrow" />
          </div>
        </div>
      </div>

      <div class="flow-section">
        <div class="flow-section-title">
          <van-icon name="shop-o" />
          <span>卖家流程</span>
        </div>
        <div class="flow-steps-seller">
          <div v-for="(step, index) in sellerSteps" :key="index" class="flow-step-item">
            <div class="step-icon seller">{{ step.icon }}</div>
            <div class="step-info">
              <div class="step-title">{{ step.title }}</div>
              <div class="step-desc">{{ step.desc }}</div>
            </div>
            <van-icon v-if="index < sellerSteps.length - 1" name="arrow" class="step-arrow" />
          </div>
        </div>
      </div>

      <div class="flow-section">
        <div class="flow-section-title">
          <van-icon name="info-o" />
          <span>分支说明</span>
        </div>
        <div class="branch-list">
          <div v-for="(item, index) in branchList" :key="index" class="branch-item">
            <div class="branch-label">{{ item.label }}</div>
            <div class="branch-content">{{ item.content }}</div>
          </div>
        </div>
      </div>

      <div class="flow-section">
        <div class="flow-section-title">
          <van-icon name="balance-o" />
          <span>保证金说明</span>
        </div>
        <div class="bond-cards">
          <div class="bond-card">
            <div class="bond-header">
              <van-icon name="shop-o" />
              <span>卖家保证金（卖家）</span>
            </div>
            <div class="bond-content">
              <div class="bond-row">
                <span class="bond-key">下单时</span>
                <span class="bond-val">校验余额是否充足</span>
              </div>
              <div class="bond-row">
                <span class="bond-key">支付时</span>
                <span class="bond-val">扣除并冻结保证金</span>
              </div>
              <div class="bond-row">
                <span class="bond-key">确认收货</span>
                <span class="bond-val">开始计算退还时间</span>
              </div>
              <div class="bond-row">
                <span class="bond-key">退还条件</span>
                <span class="bond-val">交易完成无异议自动退还</span>
              </div>
              <div class="bond-row">
                <span class="bond-key">违约赔付</span>
                <span class="bond-val">平台扣10%后赔付买家</span>
              </div>
            </div>
          </div>
          <div class="bond-card">
            <div class="bond-header">
              <van-icon name="user-o" />
              <span>买家防串保证金（买家）</span>
            </div>
            <div class="bond-content">
              <div class="bond-row">
                <span class="bond-key">下单时</span>
                <span class="bond-val">校验余额是否充足</span>
              </div>
              <div class="bond-row">
                <span class="bond-key">支付时</span>
                <span class="bond-val">扣除并冻结保证金</span>
              </div>
              <div class="bond-row">
                <span class="bond-key">确认收货</span>
                <span class="bond-val">开始计算退还时间</span>
              </div>
              <div class="bond-row">
                <span class="bond-key">退还条件</span>
                <span class="bond-val">交易完成后卖家确认退还或14天无异议系统自动退还</span>
              </div>
              <div class="bond-row">
                <span class="bond-key">违约赔付</span>
                <span class="bond-val">平台扣10%后赔付卖家</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flow-section">
        <div class="flow-section-title">
          <van-icon name="orders-o" />
          <span>订单状态说明</span>
        </div>
        <div class="status-list">
          <div v-for="(status, index) in statusList" :key="index" class="status-item">
            <van-tag :type="status.type" size="medium">{{ status.label }}</van-tag>
            <span class="status-desc">{{ status.desc }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderFlow',
  data () {
    return {
      buyerSteps: [
        { icon: '1', title: '下单', desc: '买家提交订单' },
        { icon: '2', title: '付款', desc: '买家支付订单' },
        { icon: '3', title: '确认价格及运费', desc: '等待卖家确认' },
        { icon: '4', title: '发货', desc: '卖家发货物流' },
        { icon: '5', title: '收货', desc: '买家确认收货' },
        { icon: '6', title: '完成', desc: '交易完成' },
        { icon: '7', title: '评价', desc: '买家评价' }
      ],
      sellerSteps: [
        { icon: 'A', title: '确认是否需要买家防串保证金', desc: '与买家协商' },
        { icon: 'B', title: '设置物流方式及运费', desc: '包邮/买家付/代发' },
        { icon: 'C', title: '确认产品价格', desc: '确认后发货' },
        { icon: 'D', title: '填写物流发货', desc: '填写快递信息' }
      ],
      branchList: [
        { label: '超时取消', content: '下单后30分钟未付款自动取消，恢复库存' },
        { label: '发货超时', content: '支付后12小时未发货，卖家违约赔付买家' },
        { label: '退款流程', content: '待发货可直接退款；已发货后退款需卖家审核' },
        { label: '部分退款', content: '确认收货前可申请部分退款，订单变为"部分退款"状态' },
        { label: '全额退款', content: '审核通过后原路退回，订单变为"已退款"状态' }
      ],
      statusList: [
        { label: '待付款', type: 'warning', desc: '等待买家支付，30分钟超时自动取消' },
        { label: '待发货', type: 'primary', desc: '已支付，等待卖家发货，12小时超时违约' },
        { label: '待收货', type: 'success', desc: '卖家已发货，等待买家确认，此时可申请卖家违约赔付，若确认收货后交易完成' },
        { label: '已完成', type: 'primary', desc: '买家已确认收货，若有防串保证金，卖家可主动解冻买家防串保证金或申请防串保证金赔偿' },
        { label: '已评价', type: 'success', desc: '买家已评价，交易彻底完成' },
        { label: '已退款', type: 'danger', desc: '全额退款完成，订单结束' },
        { label: '部分退款', type: 'warning', desc: '部分退款完成，交易仍有部分进行' }
      ]
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.order-flow-page {
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 20px;
}

.flow-content {
  padding: 12px;
}

.flow-section {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}

.flow-section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 16px;
}

.flow-section-title .van-icon {
  margin-right: 8px;
  font-size: 18px;
  color: #1989fa;
}

.flow-steps-buyer,
.flow-steps-seller {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.flow-step-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  position: relative;
}

.flow-step-item:not(:last-child) {
  border-bottom: 1px dashed #ebedf0;
}

.step-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #1989fa;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.step-icon.seller {
  background: #07c160;
}

.step-info {
  flex: 1;
  margin-left: 12px;
}

.step-title {
  font-size: 14px;
  color: #323233;
  font-weight: 500;
}

.step-desc {
  font-size: 12px;
  color: #969799;
  margin-top: 2px;
}

.step-arrow {
  position: absolute;
  right: 0;
  color: #969799;
  font-size: 14px;
}

.branch-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.branch-item {
  display: flex;
  align-items: flex-start;
  padding: 10px 12px;
  background: #f7f8fa;
  border-radius: 6px;
}

.branch-label {
  font-size: 13px;
  color: #1989fa;
  font-weight: 500;
  min-width: 70px;
}

.branch-content {
  font-size: 13px;
  color: #646566;
  flex: 1;
}

.bond-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bond-card {
  border: 1px solid #ebedf0;
  border-radius: 8px;
  padding: 12px;
}

.bond-header {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 10px;
}

.bond-header .van-icon {
  margin-right: 6px;
  color: #1989fa;
}

.bond-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bond-row {
  display: flex;
  font-size: 12px;
}

.bond-key {
  color: #969799;
  min-width: 60px;
}

.bond-val {
  color: #646566;
  flex: 1;
}

.status-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status-item {
  display: flex;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #ebedf0;
  white-space: nowrap;
}

.status-item:last-child {
  border-bottom: none;
}

.status-desc {
  margin-left: 12px;
  font-size: 13px;
  color: #646566;
  line-height: 1.5;
  white-space: normal;
  flex: 1;
}
</style>